import React from 'react';
import classNames from 'classnames';
import { SectionProps } from '../../utils/SectionProps';
import * as flags from '../../flag.json';
import ButtonGroup from '../elements/ButtonGroup';
import Button from '../elements/Button';
import Image from '../elements/Image';
const gif = require('../../assets/gif/giphy.gif')

const propTypes = {
  ...SectionProps.types
}

const defaultProps = {
  ...SectionProps.defaults
}

const Hero = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  ...props
}) => {

  const outerClasses = classNames(
    'hero section center-content',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'hero-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  const PublisherRoutes = () => flags.PublisherRoutes ? 
                          <ButtonGroup>
                            <Button tag="a" color="primary" wideMobile href="https://cruip.com/">
                              Explore Publishers
                            </Button>
                            <Button tag="a" color="primary" wideMobile href="https://github.com/cruip/open-react-template/">
                              Explore Top Selling Reports
                            </Button>
                            <Button tag="a" color="primary" wideMobile href="https://github.com/cruip/open-react-template/">
                              Explore Latest Reports
                            </Button>
                          </ButtonGroup> : ''

  return (
    <section
      {...props}
      className={outerClasses}
    >
      <div className="container-sm">
        <div className={innerClasses}>
          <div className="hero-content">
            <h3 className="mt-30 mb-16 reveal-from-bottom" data-reveal-delay="200">
              Data Rich Insights <br /> <span className="text-color-primary">From Enterprises to Small Scale Businesses</span>
            </h3>
            <div className="container-xs">
              <p className="m-0 mb-32 reveal-from-bottom" data-reveal-delay="400">
                Excel your Business growth with the impeccable insights of the market.
              </p>
                <div className="reveal-from-bottom" data-reveal-delay="600">
                <PublisherRoutes />
                </div>
            </div>
          </div>
          <div className="hero-figure reveal-from-bottom illustration-element-01" data-reveal-value="20px" data-reveal-delay="800">
            <Image
              className="has-shadow"
              src={gif}
              alt="Hero"
              width={448}
              height={252} />
          </div>
        </div>
      </div>
    </section>
  );
}

Hero.propTypes = propTypes;
Hero.defaultProps = defaultProps;

export default Hero;